import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiPostgresql,
  DiJava,
} from "react-icons/di";
import { FaStripe } from "react-icons/fa";
import { SiTensorflow, SiFirebase, SiTypescript, SiMysql, SiGraphql } from "react-icons/si";
import { CustomTooltip } from "../../components";

const skills = [
  { title: "C++", icon: <CgCPlusPlus /> },
  { title: "Java", icon: <DiJava /> },
  { title: "JavaScript", icon: <DiJavascript1 /> },
  { title: "TypeScript", icon: <SiTypescript /> },
  { title: "NodeJS", icon: <DiNodejs /> },
  { title: "ReactJS", icon: <DiReact /> },
  { title: "GraphQL", icon: <SiGraphql /> },
  { title: "Postgre-SQL", icon: <DiPostgresql /> },
  { title: "MySQL", icon: <SiMysql /> },
  { title: "MongoDB", icon: <DiMongodb /> },
  { title: "Python", icon: <DiPython /> },
  { title: "TensorFlow", icon: <SiTensorflow /> },
  { title: "Github", icon: <DiGit /> },
  { title: "Firebase", icon: <SiFirebase /> },
  { title: "Stripe", icon: <FaStripe /> },

]

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {skills.map((skill, i) => {
        return (<CustomTooltip key={i} title={skill.title}>
          <Col xs={4} md={2} className="tech-icons">
            {skill.icon}
          </Col>
        </CustomTooltip>)
      })}
    </Row>
  );
}

export default Techstack;
